import { createContext } from 'react';
import {
    QUERY_KEYS_SECURITY,
    useChartsData
} from '../../../../Common/hooks/useChartsData';
import { useSecurityFiltersContext } from '../../../../Seguranca/Common/Filters/hooks/useSecurityFiltersContext';

export const CrimesChartsDataContext = createContext();

const CrimesChartsDataProvider = ({ children }) => {
    const { filters } = useSecurityFiltersContext();
    const currentYear = new Date().getFullYear();
    const filterParams = {
            year: filters.year?.value || '',
            month: filters.month?.value ? String(parseInt(filters.month.value)) : '',
            location: filters.unidade.value,
            city: filters.cidade?.value,
    }

    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_SECURITY.ART173_ECA_CRIMES_DETERMINED_NATURE_EVOLUTION,
            url: 'governanceroom/securitydashboard/productivityData/art173eca/crimes/determinedNatureEvolution'
        },
        filterParams
    );

    const chartData = {
        determinedNatureEvolutionAnual: data?.anualEvolution || [],
        determinedNatureEvolutionMonth: data?.monthEvolution || []
    }

    return (
        <CrimesChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </CrimesChartsDataContext.Provider>
    );
};

export default CrimesChartsDataProvider;
